import { Switch } from "react-router-dom";
import { SentryRoute } from "sentry";

import { TermsAndConditions } from "modules/user-settings";

import { AuthorizedRoute } from "../../components/routes/AuthorizedRoute";
import UnauthorizedOnlyRoute from "../../components/routes/UnauthorizedOnlyRoute";
import { useAppRoutes } from "../../hooks/useBuildChildRoutes";
import { useRedirectToTargetPathname } from "../../hooks/useRedirectToTargetPathname";
import BasicLayout from "../../layouts/Basic";
import DashboardLayout from "../../layouts/Dashboard";
import { Page404 } from "../../pages/Page404";

function MainSwitch() {
  useRedirectToTargetPathname();

  const {
    switchAppRoutes,
    switchAuthRoutes,
    authPaths,
    appPaths,
  } = useAppRoutes();

  return (
    <Switch>
      <UnauthorizedOnlyRoute
        path={authPaths}
        render={() => (
          <BasicLayout>
            <Switch>{switchAuthRoutes}</Switch>
          </BasicLayout>
        )}
      />
      <AuthorizedRoute
        path={appPaths}
        render={() => (
          <DashboardLayout key="layout">
            <TermsAndConditions />
            <Switch>
              {switchAppRoutes}
              <SentryRoute component={Page404} />
            </Switch>
          </DashboardLayout>
        )}
      />
    </Switch>
  );
}

export default MainSwitch;
